import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { analytics } from '../../services/analytics';
import SEOPageLayout from '../../components/SEOPageLayout';

const CheckIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const InteractiveProposals = () => {
  useEffect(() => {
    analytics.track('Feature Page View', { feature: 'Interactive Proposals' });
  }, []);

  return (
    <SEOPageLayout
      title="Interactive Proposal Software - Engage Clients & Close Faster | QuoteTier"
      description="Static PDFs are dead. Send interactive proposals that let clients customize their package, select add-ons, and sign instantly from any device."
      canonical="/features/interactive-proposals"
      ogTitle="Proposals That Actually Sell"
      ogDescription="Turn your quotes into an interactive shopping experience. Clients engage more and buy more when they're in control."
    >
      <section className="py-32 md:py-40 lg:py-48">
        <div className="container max-w-7xl mx-auto px-4">
          <div className="text-center max-w-4xl mx-auto">
            <h1 className="font-instrument text-4xl sm:text-5xl md:text-6xl lg:text-7xl tracking-tight leading-tight mb-6">
              Bring Your Quotes to <span className="text-primary font-bold">Life</span>
            </h1>
            <p className="font-jetbrains text-xl md:text-2xl text-gray-600 tracking-tight leading-relaxed mb-8">
              Don't just send a price. Send an experience. Let clients build their own perfect package with interactive checkboxes and toggles.
            </p>
            <div className="font-instrument mt-12 flex flex-col sm:flex-row gap-6 justify-center items-center mb-6">
              <Link to="/signup">
                <Button className="px-8 py-4 text-xl font-semibold bg-black text-white hover:bg-gray-800 rounded-lg shadow-lg">
                  Build an Interactive Quote
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-gray-50">
        <div className="container max-w-6xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="font-instrument text-3xl md:text-4xl font-bold mb-4">More Than Just a PDF</h2>
            <p className="font-jetbrains text-lg text-gray-600">Give your clients the modern experience they expect.</p>
          </div>

          <div className="grid gap-6 md:grid-cols-3">
            <Card className="border border-black">
              <CardHeader><CardTitle className="font-instrument text-xl">Client Control</CardTitle></CardHeader>
              <CardContent><p className="font-jetbrains text-sm text-gray-600">Clients can toggle optional services on and off to see how it affects the price in real-time. It empowers them to buy.</p></CardContent>
            </Card>
            <Card className="border border-black">
              <CardHeader><CardTitle className="font-instrument text-xl">Mobile Optimized</CardTitle></CardHeader>
              <CardContent><p className="font-jetbrains text-sm text-gray-600">Over 60% of emails are opened on phones. Your proposals look perfect on any screen size, automatically.</p></CardContent>
            </Card>
            <Card className="border border-black">
              <CardHeader><CardTitle className="font-instrument text-xl">Instant Updates</CardTitle></CardHeader>
              <CardContent><p className="font-jetbrains text-sm text-gray-600">Need to change a price? Update it in QuoteTier and the client sees the new price instantly—no need to resend a file.</p></CardContent>
            </Card>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-black text-white">
        <div className="container max-w-4xl mx-auto px-4 text-center">
          <h2 className="font-instrument text-3xl md:text-4xl font-bold mb-6">Stop Sending Dead Documents</h2>
          <Link to="/signup">
            <Button className="px-10 py-4 font-instrument text-xl font-semibold bg-white text-black hover:bg-gray-200 rounded-lg shadow-lg">
              Start Free
            </Button>
          </Link>
        </div>
      </section>
    </SEOPageLayout>
  );
};

export default InteractiveProposals;
